export default __webpack_public_path__ + "783674b764b67c60903d262144a119fb.png";